import { createContext, useContext } from 'react';

export const IsInBottomSliderContext = createContext(false);

export const useIsInBottomSlider = () => useContext(IsInBottomSliderContext);
